import type { ChangeEvent } from "react";

interface FormFieldProps {
  label: string;
  name: string;
  value: string;
  onChange: (name: string, value: string) => void;
  error?: string;
  type?: string;
  placeholder?: string;
  optional?: boolean;
  maxLength?: number;
  inputMode?: "text" | "tel" | "email" | "numeric";
  autoComplete?: string;
  hint?: string;
}

export default function FormField({
  label,
  name,
  value,
  onChange,
  error,
  type = "text",
  placeholder,
  optional = false,
  maxLength,
  inputMode,
  autoComplete,
  hint,
}: FormFieldProps) {
  const handle = (event: ChangeEvent<HTMLInputElement>) => onChange(name, event.target.value);

  return (
    <label className="flex flex-col gap-1.5">
      <span className="flex items-center gap-2 text-sm text-foreground-700">
        {label}
        {optional ? (
          <span className="text-[11px] uppercase tracking-[0.14em] text-foreground-400">opcional</span>
        ) : null}
      </span>
      <input
        type={type}
        name={name}
        value={value}
        onChange={handle}
        placeholder={placeholder}
        maxLength={maxLength}
        inputMode={inputMode}
        autoComplete={autoComplete}
        aria-invalid={Boolean(error)}
        className={`rounded-md border bg-background-50 px-4 py-3 text-sm text-foreground-800 outline-none transition-colors focus:border-primary-400 ${
          error ? "border-accent-400" : "border-background-300"
        }`}
      />
      {error ? (
        <span className="flex items-center gap-1.5 text-xs text-accent-800">
          <i className="ri-error-warning-line text-sm" />
          {error}
        </span>
      ) : hint ? (
        <span className="text-xs text-foreground-500">{hint}</span>
      ) : null}
    </label>
  );
}